// src/api_scripts/getuserProfiles.js
import { fetchAllPages } from "../paginationUtils";

const getuserProfiles = async (userProfilesName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/user-profile`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "User Profiles");
    console.log("Get User Profiles API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching User Profiles:`, error);
    throw error;
  }
};

export default getuserProfiles;